import React, { useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import QRScan from "../pages/QRScan";
import MobileChart from "../pages/MobileChart";
import Home from "../pages/Home";
import Dashboard from "../pages/Home/Dashboard";
import Facility from "../pages/Home/Facility";
import FacilityType from "../pages/Home/FacilityType";
import NoteType from "../pages/Home/NoteType";
import Patient from "../pages/Home/Patient";
import Reports from "../pages/Home/Report";
import Setting from "../pages/Home/Setting";
import Notification from "../pages/Home/Notificaton";
import Staff from "../pages/Home/Staff";
import PaymentInfoNew from "../pages/PaymentInformationNew";
import NewPaymentMethod from "../pages/NewPaymentMethod";
import SimplePricing from "../pages/SimplePricing";
import ForgetPassword from "../pages/ForgetPassword";
import VerifyEmail from "../pages/VerifyEmail";
import ResetPassword from "../pages/CodeVerification";
import SupportPlan from "../pages/Home/SupportPlan";
import HaveProblem from "../pages/HaveProblem";
import MyTicket from "../pages/Home/MyTicket";
import SingleTicket from "../pages/SingleTicket";
import LandingPage from "../pages/LandingPage";
// import PricingPage from "../pages/PricingPage";
import ContactPage from "../pages/ContactPage";
import AuthPage from "../pages/AuthPage";
import BookDemoPage from "../pages/BookDemoPage";
import TermsPage from "../pages/TermsPage";
import PrivacyPage from "../pages/PrivacyPage";
import CookiesPage from "../pages/CookiesPage";
import ChatBot from "../utils/chatbot";
import Billing from "../pages/Home/Billling";
import BillingClaimForm from "../pages/Home/BillingClaimForm";
import BillingInvoices from "../pages/Home/BillingInvoices";
import InvoicePayment from "../pages/InvoicePayment";
import Success from "../pages/InvoicePayment/success";
import Error from "../pages/InvoicePayment/error";
import { UpdatePlan } from "../pages/UpgradePlan/updatePlan";
import TwoFactorAuthPage from "../pages/TwoFactorAuthPage";
import SelectTwoFactorMethod from "../pages/SelectTwoFactorMethod";
import SelectBusniesses from "../pages/SelectBusniesses";
import { OrganizationInvite } from "../pages/OrgInvitePage";
import ProviderToken from "../pages/Home/ProviderToken";
import InvoicePaymentSkypoint from "../pages/SkypointInvoicePayment";
import SuccessSkypoint from "../pages/SkypointInvoicePayment/successSkypoint";
import ErrorSkypoint from "../pages/SkypointInvoicePayment/errorSkypoint";
import { FreePlanUsers } from "../pages/FreePlanUsers";
import PaymentSuccess from "../pages/PaymentInformationNew/PaymentSuccess";
import { ServicePlanPage } from "../pages/ServicePlanPage";
import SmsUploadPage from "../pages/SmsUploadPage";

function DemoSelfGuideRedirect() {
  useEffect(() => {
    window.location.href = "/demo-self-guide/index.html";
  }, []);
  return null;
}

function Router() {
  return (
    <>
      <ScrollToTop />
      <ChatBot />
      <Routes>
        <Route path="/demo-self-guide/*" element={<DemoSelfGuideRedirect />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<AuthPage defaultView="signup" />} />
        <Route path="/login" element={<AuthPage defaultView="login" />} />
        <Route path="/2fa" element={<TwoFactorAuthPage />} />
        <Route path="/select-2fa-method" element={<SelectTwoFactorMethod />} />
        <Route path="/select-busniesses" element={<SelectBusniesses />} />
        <Route
          path="/organization-invite/:token/:orgName"
          element={<OrganizationInvite />}
        />
        <Route
          path="/service-plan/:token/:mode?"
          element={<ServicePlanPage />}
        />

        {/* <Route path="/pricing" element={<PricingPage />} /> */}
        <Route path="/pricing" element={<Navigate to="/" replace />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/book-demo" element={<BookDemoPage />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/verify-email-update/:token" element={<VerifyEmail />} />
        {/* <Route path="/confirm-upgrade-plan" element={<UpgradePlan />} /> */}
        <Route path="/confirm-update-plan" element={<UpdatePlan />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

        {/* for invoicepayment */}
        <Route path="/invoice-payment" element={<InvoicePayment />} />
        <Route path="/success" element={<Success />} />
        <Route path="/error" element={<Error />} />

        <Route path="/invoice-payment-skypoint" element={<InvoicePaymentSkypoint />} />
        <Route path="/success-skypoint" element={<SuccessSkypoint />} />
        <Route path="/error-skypoint" element={<ErrorSkypoint />} />

        {/* for invoicepayment */}

        <Route path="/provider-token" element={<ProviderToken />} />
        <Route path="/scan/:clientId" element={<QRScan />} />
        <Route path="/mobile-chart" element={<MobileChart />} />
        <Route path="/upload" element={<SmsUploadPage />} />

        <Route path="/selectprice" element={<SimplePricing />} />
        <Route path="/free-plan-users" element={<FreePlanUsers />} />
        <Route path="/payInfo" element={<PaymentInfoNew />} />
        <Route path="/add-payment" element={<NewPaymentMethod />} />
        <Route path="/term-conditions" element={<TermsPage />} />
        <Route path="/cookies-policy" element={<CookiesPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />

        <Route path="/home/*" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="supportPlan" element={<SupportPlan />} />
          <Route path="facility" element={<Facility />} />
          <Route path="facilitytype" element={<FacilityType />} />
          <Route path="staff" element={<Staff />} />
          <Route path="report" element={<Reports />} />
          <Route path="patient" element={<Patient />} />
          <Route path="note" element={<Dashboard />} />
          <Route path="notetype" element={<NoteType />} />
          <Route path="settings" element={<Setting />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="tickets" element={<MyTicket />} />
          <Route path="ticket/:id" element={<SingleTicket />} />
          <Route path="create-ticket" element={<HaveProblem />} />
          <Route path="billing" element={<Billing />} />
          <Route path="billing-claim-form" element={<BillingClaimForm />} />
          <Route path="invoices" element={<BillingInvoices />} />
        </Route>
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
      </Routes>
    </>
  );
}

export default Router;
